export default "__VITE_ASSET__DSwHCzs4__"